<script lang="ts" setup>
import IconMaterialSymbolsLightStar from '~icons/material-symbols-light/star';
import IconMaterialSymbolsLightStarOutline from '~icons/material-symbols-light/star-outline';

const props = defineProps<{
	isSelected: boolean;
	isMainPulsing: boolean;
	isBackgroundPulsing: boolean;
}>();
</script>

<template>
	<div class="relative flex items-center justify-center">
		<!-- Background star pulse -->
		<IconMaterialSymbolsLightStar
			:class="[
				'absolute size-6 transition-all duration-300',
				props.isSelected ? 'text-primary/40' : 'text-white-dark-4',
				props.isBackgroundPulsing
					? 'scale-[2] opacity-60'
					: 'scale-100 opacity-0'
			]"
		/>

		<component
			:is="
				props.isSelected
					? IconMaterialSymbolsLightStar
					: IconMaterialSymbolsLightStarOutline
			"
			:class="[
				'relative z-10 size-6 scale-110 text-primary transition-transform duration-300 ease-out',
				props.isMainPulsing && !props.isSelected && 'scale-[1.4]'
			]"
		/>
	</div>
</template>
